<script setup>
    import { ref, onMounted, getCurrentInstance, inject } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import {usePageLoadingStore} from "../../../../stores/pageLoading";
    import {useMatchingUpdateStore} from "../../../user/stores/matching/matchingUpdateStore";
    import adminUserService from "../../services/user/adminUserService";
    import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
    import { useAlertStore } from "../../../../stores/alertStore";
    import MemberInfoView from "@/pages/admin/views/member/detail/MemberInfoView.vue";
    import MemberLectureHistoryView from "@/pages/admin/views/member/detail/MemberLectureHistoryView.vue";
    import MemberLectureTeacherView from "@/pages/admin/views/member/detail/MemberLectureTeacherView.vue";
    import MemberUserGroupHistoryView from "@/pages/admin/views/member/detail/MemberUserGroupHistoryView.vue";
    import MemberJobFairSateView from "@/pages/admin/views/member/detail/MemberJobFairSateView.vue";
    import MemberUserJobApplyView from "@/pages/admin/views/member/detail/MemberUserJobApplyView.vue";
    import MemberMatchingTabView from "@/pages/admin/views/member/MemberMatchingTabView.vue";
    import MemberUserMatchingTabView from "@/pages/admin/views/member/MemberUserMatchingTabView.vue";

    const { $alert, $confirm } = useAlertStore();

    const route = useRoute()
    const router = useRouter()
    const loadingStore = usePageLoadingStore()
    const matchingUpdateStore = useMatchingUpdateStore()
    //const loaded = ref(false);
    const { $interests, $corpState, $ojfStateGb, $adminJoinStateGb, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $yyyymm, $gb, $bizNum, $userGbKR } = getCurrentInstance().appContext.config.globalProperties;

    const user = ref({
        userId: '',
    })

    onMounted(()=> {
        const { id } = route.params;
        if(!id) {
            goBack()
        } else {
            user.value.userId = id;
            retrieveUserDetail(id);
        }
    })

    const BASIC = 'BASIC';                       // 기본 정보
    const LECT_HIST = 'LECT_HIST';               // 수강 내역
    const MATCH_HIST = 'MATCH_HIST';             // 상시채용관 진행 현황 (기업)
    const MATCH_USER_HIST = 'MATCH_USER_HIST';   // 상시채용관 진행 현황 (구직자)
    const LECT_CREATE_HIST = 'LECT_CREATE_HIST'; // 강의 개설 내역
    const USER_GB_HIST = 'USER_GB_HIST';         // 회원 유형 변경 내역
    const JOB_FAIR_HIST = 'JOB_FAIR_HIST';       // 특별채용관 참가 현황
    const JOB_APPLY_HIST = 'JOB_APPLY_HIST';       // 기업홍보관 입사지원 현황

    const tabIndex = ref(BASIC)

    const tabOptions = ref([
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
    ])

    const tabOptionsTeacher = ref([  // 강사
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '강의 개설 내역', value: LECT_CREATE_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
    ])

    const tabOptionsCompany = ref([  // 기업
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
        {label: '상시채용관 진행 현황', value: MATCH_HIST},
        {label: '특별채용관 참가 현황', value: JOB_FAIR_HIST},
    ])

    const tabOptionsStudent = ref([  // 학생
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
        {label: '상시채용관 진행 현황', value: MATCH_USER_HIST},
        {label: '특별채용관 참가 현황', value: JOB_FAIR_HIST},
        {label: '기업홍보관 입사지원 현황', value: JOB_APPLY_HIST},
    ])

    // '탈퇴' 버튼
    const deleteUser = async () => {
        const ok = await $confirm(["회원을 탈퇴 시킬까요?", "탈퇴 시 모든 회원 정보는 삭제되며 되돌릴 수 없습니다."], "탈퇴");

        if(ok) {
            loadingStore.loading = true;
            adminUserService.deleteUser(user.value.userId)
                .then( async (res) => {
                    loadingStore.loading = false;
                    // console.log(res);
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        console.log(result);
                        goBack();
                    } else {
                        $alert("사용자 탈퇴를 실패하였습니다.");
                    }
                }).catch( (res) =>  {
                // console.log(res);
                loadingStore.loading = false;
                $alert(res.response.data.result.message);
            });
        }
    }

    // s: 기본 정보 TAB
    // 1. 기본 정보(이력서 정보 제외)
    const retrieveUserDetail = (userId) => {
        loadingStore.loading = true;
        adminUserService.retrieveUser(userId || user.value.userId)
            .then( async (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    user.value = res.data.result;
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
        });
    }
    // e: 기본 정보 TAB

    // 탭 선택 이벤트
    const onChangeTab = ({ value }) => {
        tabIndex.value = value;
    }

    const goBack = () => {
        router.push({name: 'MemberList'})
    }
</script>

<template>
    <div class="content">
        <div class="sub-title space-between">
            <h3>{{ user.userName }}님 회원정보</h3>
        </div>

        <div class="btn-wrap space-between mb-xs">
            <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
            <KSASecondaryButton class="red_button" text="탈퇴" @click="deleteUser" />
        </div>

        <KSATab v-if="user.userGb === 'STUDENT'" style="grid-template-columns: repeat(6, 1fr);" class="mb-lg" :options="tabOptionsStudent" @change="onChangeTab"/>
        <KSATab v-else-if="user.userGb === 'COMPANY'" style="grid-template-columns: repeat(5, 1fr);" class="mb-lg" :options="tabOptionsCompany" @change="onChangeTab"/>
        <KSATab v-else-if="user.userGb === 'TEACHER'" style="grid-template-columns: repeat(4, 1fr);" class="mb-lg" :options="tabOptionsTeacher" @change="onChangeTab"/>
        <KSATab v-else style="grid-template-columns: repeat(3, 1fr);" class="mb-lg" :options="tabOptions" @change="onChangeTab"/>

        <!-- s: 기본 정보 -->
        <div v-if="tabIndex === BASIC">
            <MemberInfoView :user="user" />
        </div>
        <!-- e: 기본 정보 -->

        <!-- s: 수강내역 -->
        <div v-if="tabIndex === LECT_HIST">
            <MemberLectureHistoryView :user="user" />
        </div>
        <!-- e: 수강내역 -->

        <!-- s: 회원 유형 변경 내역 -->
        <div v-if="tabIndex === USER_GB_HIST">
          <MemberUserGroupHistoryView :user="user" />
        </div>
        <!-- e: 회원 유형 변경 내역 -->

        <!-- s : 상시채용관 진행 현황 - 기업  -->
        <div v-if="tabIndex === MATCH_HIST">
          <MemberMatchingTabView :user="user" />
        </div>
        <!-- e: 상시채용관 진행 현황 - 기업 -->

        <!-- s : 상시채용관 진행 현황 - 구직자 -->
        <div v-if="tabIndex === MATCH_USER_HIST">
          <MemberUserMatchingTabView :user="user" />
        </div>
        <!-- e: 상시채용관 진행 현황 - 구직자 -->

        <!-- s: 강의 개설 내역 -->
        <div v-if="tabIndex === LECT_CREATE_HIST">
          <MemberLectureTeacherView :user="user" />
        </div>
        <!-- e: 강의 개설 내역 -->

        <!-- s: 특별채용관 참가 현황 -->
        <div v-if="tabIndex === JOB_FAIR_HIST">
          <MemberJobFairSateView :user="user" />
        </div>
        <!-- e: 특별채용관 참가 현황 -->

        <!-- s: 기업홍보관 입사지원 현황 -->
        <div v-if="tabIndex === JOB_APPLY_HIST">
          <MemberUserJobApplyView :user="user" />
        </div>
        <!-- e: 기업홍보관 입사지원 현황 -->

    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    h1 {
        @include font-size_lg;
        margin: 60px 0 30px;
    }

    .blue {
      color: $blue_color;
    }

    .table-form {
        table {
            &.vertical {
                &.align-left {
                    th {
                        text-align: left;
                        span {
                            display: block;
                            font-size: $font-size_xs;
                            color: $gray_color;
                            font-weight: normal;
                        }
                    }
                }
            }
          width: 100%;
        }
        .clickable {
            text-decoration: underline;
            cursor: pointer;
        }
    }
</style>